// extracted by mini-css-extract-plugin
export default {"bannerStart":"Banner_bannerStart__I89kO","header":"Banner_header__8GX7V","text":"Banner_text__qCYnp","image":"Banner_image__er8Xl"};